import React from 'react';
import { Heart } from 'lucide-react';

export default function Wishlist({ notes, toggleWishlist, deleteNote }) {
  const wishlisted = notes.filter(n => n.isWishlisted);

  if (wishlisted.length === 0) return (
    <div className="text-center py-32 text-gray-400">
      <Heart size={60} className="mx-auto text-pink-50 mb-4" fill="currentColor" />
      <p className="font-bold">Wishlist is empty</p>
    </div>
  );

  return (
    <div className="animate-in fade-in duration-500">
      <h1 className="text-2xl font-black text-gray-800 mb-8">Favorites</h1>
      <div className="grid gap-4">
        {wishlisted.map(n => (
          <div key={n.id} className="bg-white p-6 rounded-[2rem] border relative">
            <button onClick={() => toggleWishlist(n.id)} className="absolute top-6 right-6"><Heart size={22} className="fill-red-500 text-red-500" /></button>
            <h3 className="font-bold text-xl mb-1">{n.title}</h3>
            <p className="text-gray-500 text-sm line-clamp-2">{n.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}